import { useState, useEffect } from 'react';
import mapData from 'utils/map-data';
import fetchWordpress from '../../api/wordpress';

export default function useWordpress({ id, type }) {
  const [pageData, setPageData] = useState(null);
  const callWordpress = async () => {
    const pageData = id
      ? await fetchWordpress(`${type === 'post' ? 'posts' : 'pages'}/${id}`)
      : null;
    const data = await mapData.templateData(pageData);
    const wpData = mapData.pageData(data);
    const newPagedata = {
        ...wpData,
      };
    setPageData({ ...newPagedata });
  };
  useEffect(() => {
    callWordpress();
  }, []);
  return pageData;
}
